import { FieldType, Field, ComparisonOperator } from "../../vforms-model";
import { TextareaComponent } from "./textarea.component";
import { TextareaEditorComponent } from "./textarea-editor.component";
import { TextBox } from "../text-box/text-box";
import { ComparisonExpression } from "../../expression-settings/model";

export class TextareaType extends FieldType {
    static Id = "textarea";

    constructor() {
        super();
        this.id = TextareaType.Id;
        this.icon = "mat_outline:wrap_text";
        this.previewComponent = TextareaComponent;
        this.editorComponent = TextareaEditorComponent;
    }

    createField(): Field {
        return new Textarea(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [
            ...super.supportedComparisonOperators(),
            ComparisonOperator.Equal,
            ComparisonOperator.NotEqual,
            ComparisonOperator.Contains,
            ComparisonOperator.NotContains,
        ];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        let lowerCaseValue = value?.toLowerCase();
        let lowerCaseExpressionValue = expression.value?.toLowerCase();
        switch (expression.operator) {
            case ComparisonOperator.Equal:
                return lowerCaseValue === lowerCaseExpressionValue;
            case ComparisonOperator.NotEqual:
                return lowerCaseValue != lowerCaseExpressionValue;
            case ComparisonOperator.Contains:
                return lowerCaseValue && lowerCaseValue.includes(lowerCaseExpressionValue);
            case ComparisonOperator.NotContains:
                return !lowerCaseValue || !lowerCaseValue.includes(lowerCaseExpressionValue);
        }
        return super.evaluate(expression, value);
    }
}

export class Textarea extends TextBox {}
